import { render, staticRenderFns } from "./CallCentreStatusTabs.vue?vue&type=template&id=455af799&scoped=true"
import script from "./CallCentreStatusTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CallCentreStatusTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CallCentreStatusTabs.vue?vue&type=style&index=0&id=455af799&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "455af799",
  null
  
)

export default component.exports